import { render } from "./SectionDrawer.vue?vue&type=template&id=5b96427b&scoped=true"
import script from "./SectionDrawer.vue?vue&type=script&lang=js"
export * from "./SectionDrawer.vue?vue&type=script&lang=js"

import "./SectionDrawer.vue?vue&type=style&index=0&id=5b96427b&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b96427b"]])

export default __exports__